// extracted by mini-css-extract-plugin
export default {"Root":"RAamBSl53vQyxYD07YYg","SidebarContainer":"JnH7s5FSo78U8ska7n3Q","MainContainer":"LDUpcPEntGlxgbEKb5PY","Content":"r8hLiWIJouweuVfQhkKC"};